import { handleActions } from "redux-actions";
import { setTimer } from "../actions/actions";

export default handleActions(
  {
    [setTimer]: (state, action) => {
      return action.payload;
    },
  },
  ""
);
